import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Copy = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: false,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
      style={style}
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        d='M4.99 3.372c-.548 0-1 .452-1 1v10c0 .548.452 1 1 1a1 1 0 0 1 0 2c-1.653 0-3-1.348-3-3v-10c0-1.652 1.347-3 3-3h10c1.652 0 3 1.348 3 3a1 1 0 1 1-2 0c0-.548-.453-1-1-1zm6 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1zm-3 1a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-10a3 3 0 0 1-3-3z'
        clipRule='evenodd'
      />
    </svg>
  );
};
